window.addEventListener('load', function() {


    // get #reply-title
    let replyTitle = document.getElementById('reply-title');
    if(replyTitle) {
       // click on reply title, toggle 'active' class on replytitle, and on #commentform
        replyTitle.addEventListener('click', function() {
            replyTitle.classList.toggle('active');
            document.getElementById('commentform').classList.toggle('active');
        });

    }


    // lookeen__comments
    let comments = document.querySelector('.lookeen__comment-meta');
    if(comments) {
        comments.addEventListener('click', function(e) {
            // toggle 'active' class on .lookeen__comments and .lookeen__comment-list
            comments.classList.toggle('active');
            document.querySelector('.lookeen__comment-list').classList.toggle('active');
        });
    }

});